module.exports = __webpack_public_path__ + "fonts/icomoon.6533388.eot";